import React from 'react';

import { observer } from 'mobx-react';
import { AxiosError } from 'axios';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';
import { ColumnActions } from 'components/Grid/types';
import { EntityFieldType } from 'utils/api/modules/entities/entities.types';
import { useStore } from 'utils/hooks/store';
import useFieldManagerParams from 'utils/hooks/useFieldManagerParams';

interface Props {
  rowData: EntityFieldType;
  actions: ColumnActions;
}

const FieldManagerActionCell: React.FC<Props> = ({ rowData, actions }) => {
  const {
    entityFields: { deleteField, setActiveField },
    notification,
  } = useStore();

  const moduleName = useFieldManagerParams();

  const handleDelete = async (): Promise<void> => {
    try {
      await deleteField(moduleName, rowData.uuid);
      notification.enqueueSuccessSnackbar('Field deleted successfully');
      await actions.refreshData();
    } catch (e) {
      const error = e as AxiosError<string[]>;
      notification.enqueueErrorSnackbar(error.response?.data?.[0] || 'Failed to delete field');
    }
  };

  const actionConfigs: ActionConfig[] = [
    {
      id: 'edit-button',
      label: rowData.editable ? 'Edit' : 'View',
      onClick: () => {
        setActiveField(rowData);
      },
    },
    {
      id: 'remove-button',
      label: 'Delete',
      visible: rowData.removable,
      onClick: handleDelete,
      confirmation: {
        type: 'text-input',
        title: 'Delete Field',
        message: 'Are you sure you want to delete this field?',
      },
    },
  ];

  return <ActionCell actions={actionConfigs} recordName={rowData.name} />;
};

export default observer(FieldManagerActionCell);
